module.exports = __webpack_public_path__ + "static/media/0.73476783.jpg";